import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit,
  Output
} from '@angular/core';
import { filter, takeUntil } from 'rxjs/operators';

import { AssessmentLevelsService } from 'app/assessment/assessment-levels.service';
import { AssessmentInfoViewModel } from 'app/assessment/AssessmentInfoViewModel';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { isNilOrEmpty } from 'helpers';

@Component({
  selector: 'app-assessment-buttons',
  templateUrl: './assessment-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssessmentButtonsComponent extends WithDisposableSubject() implements OnInit, OnDestroy {
  @Input() horizontal: boolean;
  // Will adjust the text of the buttons based on the entity type and overrides
  @Input() entityTypeId: string | null = null;
  @Output() selected = new EventEmitter<AssessmentInfoViewModel>();
  assessmentInfos: AssessmentInfoViewModel[];

  constructor(
    private assessmentLevelsService: AssessmentLevelsService,
    private cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.assessmentLevelsService.getAssessmentInfoViewModelsForEntityType(this.entityTypeId)
      .pipe(
        takeUntil(this.disposer),
        filter(vi => !isNilOrEmpty(vi))
      ).subscribe(ais => {
        this.assessmentInfos = ais;
        this.cd.markForCheck();
      });
  }

  onLevelClicked(ai: AssessmentInfoViewModel) {
    this.selected.emit(ai);
  }

  getClass(ai: AssessmentInfoViewModel) {
    const color = `a${ai.color}`;
    if (this.horizontal) {
      return `assessAdd__btn ${color}`;
    } else {
      return `assessUpdate__btn ${color}`;
    }
  }
}
